import React from 'react';

import IconEye from '../IconEye/IconEye';

import css from './ListingCard.module.scss';

const TopListingByViewBlock = (props) => {
  const { pageViewCount } = props;

  return (
    <div className={css.counters}>
      <IconEye />
      <div>Views: <span>{pageViewCount}</span></div>
    </div>
  );
};

export default TopListingByViewBlock;
